/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconOpenInNewTab12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M4.5 2.5h1v-1h-1c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C1.5 3.102 1.5 3.568 1.5 4.5v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083c.367.152.833.152 1.765.152h3c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083c.152-.367.152-.833.152-1.765v-1h-1v1c0 .48 0 .79-.017 1.026-.015.228-.042.315-.06.357a1 1 0 0 1-.54.54c-.042.018-.129.045-.357.06C8.29 9.5 7.98 9.5 7.5 9.5h-3c-.48 0-.79 0-1.026-.017-.228-.015-.315-.042-.357-.06a1 1 0 0 1-.54-.54c-.018-.042-.045-.129-.06-.357A16.911 16.911 0 0 1 2.5 7.5v-3c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 0 1 .54-.54c.042-.018.129-.045.357-.06C3.71 2.5 4.02 2.5 4.5 2.5Z"
                fill="currentColor"
            />
            <path d="M7 1.5v1h1.79L4.84 6.45l.706.707L9.5 3.205V5h.996V1.501H7Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconOpenInNewTab16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M6 3.333h1.333V2H6c-1.243 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443C2 4.136 2 4.757 2 6v4c0 1.242 0 1.864.203 2.354.27.653.79 1.172 1.443 1.443C4.136 14 4.757 14 6 14h4c1.242 0 1.864 0 2.354-.203a2.666 2.666 0 0 0 1.443-1.443C14 11.864 14 11.243 14 10V8.667h-1.333V10c0 .64-.001 1.052-.023 1.368-.02.304-.056.42-.079.476a1.334 1.334 0 0 1-.721.721c-.056.023-.172.059-.476.08-.316.02-.729.022-1.368.022H6c-.64 0-1.052-.001-1.368-.023-.304-.02-.42-.056-.476-.079a1.334 1.334 0 0 1-.721-.721c-.023-.056-.059-.172-.08-.476A22.556 22.556 0 0 1 3.334 10V6c0-.64.001-1.052.023-1.368.02-.304.056-.42.079-.476.135-.326.395-.586.721-.721.056-.023.172-.059.476-.08.316-.02.729-.022 1.368-.022Z"
                fill="currentColor"
            />
            <path
                d="M9.333 2v1.333h2.388L6.452 8.601l.943.943 5.271-5.271v2.394h1.329V2.002L9.333 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconOpenInNewTab20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M7.5 4.167h1.667V2.5H7.5c-1.553 0-2.33 0-2.942.254a3.333 3.333 0 0 0-1.804 1.804C2.5 5.17 2.5 5.947 2.5 7.5v5c0 1.553 0 2.33.254 2.942a3.334 3.334 0 0 0 1.804 1.804c.612.254 1.389.254 2.942.254h5c1.553 0 2.33 0 2.942-.254a3.334 3.334 0 0 0 1.804-1.804c.254-.612.254-1.389.254-2.942v-1.667h-1.667V12.5c0 .8 0 1.315-.027 1.71-.026.38-.07.525-.1.595-.169.408-.493.732-.901.902-.07.028-.215.073-.595.098-.395.027-.91.028-1.71.028h-5c-.8 0-1.315 0-1.71-.027-.38-.026-.525-.07-.594-.1a1.667 1.667 0 0 1-.902-.901c-.03-.07-.074-.215-.1-.595-.026-.395-.027-.91-.027-1.71v-5c0-.8 0-1.315.028-1.71.025-.38.07-.525.099-.594.169-.409.493-.733.902-.902.069-.03.214-.074.594-.1.395-.026.91-.027 1.71-.027Z"
                fill="currentColor"
            />
            <path
                d="M11.667 2.5v1.667h2.984l-6.586 6.585 1.179 1.178 6.589-6.589v2.992h1.66v-5.83L11.667 2.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconOpenInNewTab24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M9 5h2V3H9c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 3.303 5.47C3 6.204 3 7.136 3 9v6c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C6.204 21 7.136 21 9 21h6c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C21 17.796 21 16.864 21 15v-2h-2v2c0 .96-.001 1.578-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119-.474.032-1.093.033-2.052.033H9c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C5.001 16.578 5 15.96 5 15V9c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C7.42 5.001 8.04 5 9 5Z"
                fill="currentColor"
            />
            <path d="M14 3v2h3.58l-7.902 7.902 1.415 1.414L19 6.41V10h1.992V3.003L14 3Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconOpenInNewTab = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconOpenInNewTab12 {...iconProps} />;
        case '16':
            return <IconOpenInNewTab16 {...iconProps} />;
        case '20':
            return <IconOpenInNewTab20 {...iconProps} />;
        case '24':
            return <IconOpenInNewTab24 {...iconProps} />;
        default:
            return <IconOpenInNewTab24 {...iconProps} />;
    }
});
